<template>
  <v-list-item
    dense
    class="pr-4"
    v-on="$listeners"
  >
    <v-list-item-title
      class="font-weight-medium d-flex align-center"
      :class="{'ml-6': subcategoryIndex !== null}"
    >
      <span
        v-if="!question.published"
      >
        <v-icon
          small
          color="warning"
          class="mr-2"
        >mdi-eye-off-outline</v-icon>  
      </span>
      {{ question.default_translation.title }}
    </v-list-item-title>
    <v-list-item-action>
      <v-btn
        icon
        small
        :disabled="filterActive"
        @click.prevent.stop="handleMoveItemUp"
      >
        <v-icon>
          mdi-arrow-up
        </v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        icon
        small
        :disabled="filterActive"
        @click.prevent.stop="handleMoveItemDown"
      >
        <v-icon>
          mdi-arrow-down
        </v-icon>
      </v-btn>
    </v-list-item-action>
    <v-list-item-action>
      <v-btn
        ref="btn"
        icon
        small
        @click.prevent.stop="handleShowOptionsMenu"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    questionIndex: {
      type: Number,
      required: true
    },
    categoryIndex: {
      type: Number,
      required: true
    },
    subcategoryIndex: {
      type: Number,
      required: false,
      default: null
    },
    filterActive: {
      type: Boolean
    }
  },

  computed: {
    type() {
      return this.subcategoryIndex !== null ? 'subcategory-question' : 'category-question';
    }
  },

  methods: {
    handleShowOptionsMenu() {
      this.$emit('show-options-menu', this.type, this.question, this.$refs.btn.$el);
    },

    eventPayload() {
      const payload = {
        type: this.type,
        quesIdx: this.questionIndex,
        catIdx: this.categoryIndex,
        subcatIdx: this.subcategoryIndex
      };

      return payload;
    },

    handleMoveItemUp() {
      this.$emit('move-item-up', this.eventPayload());
    },

    handleMoveItemDown() {
      this.$emit('move-item-down', this.eventPayload());
    }
  }
}
</script>